import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';
import {fetchDgs} from './fetchDgs';

const DOWNLOAD_LINKS_URL =
  getQueryParams().test === 'true'
    ? 'http://localhost:3102/get_download_links'
    : 'https://dgs.wixapps.net/pp/get_download_links';

export const dgsRequest = async ({
  instance,
  paymentsId,
  sToken,
  ref,
  albumId,
  trackId = null,
  ...query
}: {
  instance: string;
  paymentsId: string | null;
  sToken: string;
  ref: string;
  albumId: string;
  trackId?: number | null;
  subscribeEmail?: string;
}) => {
  const response = await fetchDgs({
    url: DOWNLOAD_LINKS_URL,
    params: {
      instance,
      paymentsId,
      sToken,
      ref,
      collectionId: albumId,
      itemId: trackId || -1,
      ...query,
    },
  });
  return response.data;
};
